module.exports = __webpack_public_path__ + "static/assets/dd6170de8bb444a0f4846640a4301ee2.svg";